import { Mesh, Object3D } from 'three';
import { BaseDynamicArticlePostParseProcessor } from '@project/components/article/processor/postparse/base-dynamic-article-post-parse.processor';
import { ArticlesCreator } from '@project/components/article/presenter/article-creator';
import { NumberUtils } from '@shared/util/number-utils';
import { ArticleUsageInfoPropertyDef } from '@article/constants/article-usage-info-property-def';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { Connection } from '@3d-scene/model3d/connection';

export class BusbarOrCoverArticlePostParseProcessor extends BaseDynamicArticlePostParseProcessor {
  protected getStretchLength(container: ArticleContainer): number {
    let stretchLength: number = super.getStretchLength(container);
    const additionalLengthStart: number = ArticleUsageUtils.getArticleUsageInfoPropertyFloatValue(
      container.articleUsage,
      ArticleUsageInfoPropertyDef.ARTICLE_ADDITIONAL_LENGTH_START
    );
    if (NumberUtils.isNumber(additionalLengthStart)) {
      stretchLength += additionalLengthStart;
    }
    const additionalLengthEnd: number = ArticleUsageUtils.getArticleUsageInfoPropertyFloatValue(
      container.articleUsage,
      ArticleUsageInfoPropertyDef.ARTICLE_ADDITIONAL_LENGTH_END
    );
    if (NumberUtils.isNumber(additionalLengthEnd)) {
      stretchLength += additionalLengthEnd;
    }
    return stretchLength;
  }

  protected changeStaticConnectionMesh(
    connectionMesh: Mesh,
    parentContainer: Object3D,
    articleContainer: ArticleContainer,
    extrusionLength: number
  ): void {
    const connection: Connection = articleContainer.findConnectionByName(connectionMesh.name);
    if (connection) {
      const rangeOnLineMesh: Object3D = ArticlesCreator.stretchRangeOnLineConnection(connectionMesh, connection, extrusionLength);
      if (rangeOnLineMesh) {
        this.removeFromParent(connectionMesh, parentContainer);
        parentContainer.add(rangeOnLineMesh);
      }
    } else {
      this.removeFromParent(connectionMesh, parentContainer);
    }
  }
}
